import { type MachineContextType } from '#src/state-machine/types';

export type SettingsEntry = {
  showFilter: boolean;
  selectedValues: string[];
};
export type GfxSettings = {
  dataset: SettingsEntry;
  categoryId: SettingsEntry;
  categoryValue: SettingsEntry;
  levelValue: SettingsEntry;
  levelId: SettingsEntry;
  view_type: {
    selectedValues: ViewType[];
  };
  allowed_view_types: {
    selectedValues: ViewType[];
  };
  defaultQuery: SettingsEntry;
};
export type AppProps = {
  urlContext?: Partial<MachineContextType>;
  settings: GfxSettings;
};

export type YearsMode = 'single' | 'multiple' | 'range';
export type SelectionMode = 'default' | 'custom';

export type CompareBy = ('level' | 'category' | 'fundingSource')[];
export type AggregationGroup = string[];
export type Compare = AggregationGroup[];

export type ViewType = 'chart' | 'map' | 'table';
export type ChartType = 'bar' | 'line' | 'area';
export type TableDataViewType = 'absolute' | 'share' | 'percentage';

export type DropdownOption = { id: string; name: string };
export type HierarchyOption = { id: string };
export type HierarchyItem = {
  id: string;
  geoLevelId: string | null;
  contextualDatasetLevelId: string | null;
  options?: HierarchyOption[];
};

export type ParentOption = {
  id: string;
  name: string;
  shortName: string;
  options?: DropdownOption[];
  geoLevelId: string | null;
  contextualDatasetLevelId: string | null;
};
export type ParentOptions = ParentOption[];

export type HierarchyOptions = Record<string, HierarchyItem>;
export type ParentOptionsMap = Record<string, ParentOption>;

export type DataPoint = {
  date: Date;
  value: number;
  level: string;
  category: string;
  geoId: string | null;
  sublevelId: string | null;
  subcategoryId: string | null;
  fundingSourceId: string | null;
  percentGrowthLastYear: number;
};
export type DatasetData = DataPoint[];

export type SummaryItem = {
  id: string;
  year: number;
  value: number;
  percentGrowthLastYear: number;
};

export type SummaryData = SummaryItem[];

export type GeoDataItem = {
  year: number;
  geoData: Record<string, Record<string, string>>;
};

export type GeoData = GeoDataItem[];

export type DatasetLabels = {
  level: Record<string, string>;
  category: Record<string, string>;
  fundingSource: Record<string, string>;
  datasetName: string;
  datasetUnit: string;
  contextualDatasetUnit: string;
  contextualDatasetName: string;
};

export type DatasetOption = {
  id: string;
  name: string;
  unit: string;
  unitName: string;
  shortName: string | null;
};

export type OneDimensionData = {
  value: number;
  date: number;
  percentGrowthLastYear: number;
  level: string;
  category: string;
  fundingSource: string;
};

export type TwoDimensionData = Record<string, OneDimensionData>;

export type ThreeDimensionData = Record<string, TwoDimensionData>;

export type TableData<T> = Record<number | string, T>;
export type TableType = 'oneDimension' | 'twoDimensions' | 'threeDimensions';

export type Limits = {
  comparisonLimit: number;
  aggregationLimit: number;
};

export enum DefaultFilterValues {
  level = 'GLB',
  category = 'ALL',
  fundingSource = 'ALS',
  earmarking = 'EMK',
  regions = 'REG',
  operations = 'OPR',
  donors = 'DNR',
}
